"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIResultsMessage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var RenderProp = _interopRequireWildcard(require("../utils/propTypes/renderProp"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _H = _interopRequireDefault(require("../elements/headings/H2"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _UIIllustration = _interopRequireDefault(require("../image/UIIllustration"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _illustrationName = require("../utils/propTypes/illustrationName");

var MessageOuter = (0, _styledComponents.default)(_UISection.default).withConfig({
  displayName: "UIResultsMessage__MessageOuter",
  componentId: "qmydks-0"
})(["text-align:center;"]);
var MessageImage = (0, _styledComponents.default)(_UIIllustration.default).withConfig({
  displayName: "UIResultsMessage__MessageImage",
  componentId: "qmydks-1"
})(["margin-bottom:40px;"]);
var defaultIllustrationProps = {
  width: 175
};

var renderTitle = function renderTitle(title) {
  if (!title) return null;
  if (_react.default.isValidElement(title)) return title;
  return _react.default.createElement(_H.default, null, (0, _lazyEval.default)(title));
};

var renderImage = function renderImage(illustration, illustrationProps, Image) {
  if (!illustration && !Image) return null;
  return _react.default.createElement(Image, Object.assign({
    name: illustration
  }, defaultIllustrationProps, illustrationProps));
};

function UIResultsMessage(props) {
  var Body = props.Body,
      children = props.children,
      illustration = props.illustration,
      illustrationProps = props.illustrationProps,
      Image = props.Image,
      title = props.title,
      rest = (0, _objectWithoutProperties2.default)(props, ["Body", "children", "illustration", "illustrationProps", "Image", "title"]);
  return _react.default.createElement(MessageOuter, Object.assign({}, rest, {
    role: "alert",
    use: "island"
  }), renderImage(illustration, illustrationProps, Image), renderTitle(title), _react.default.createElement(Body, null, children));
}

UIResultsMessage.propTypes = {
  Body: _propTypes.default.elementType,
  children: _propTypes.default.node,
  illustration: (0, _illustrationName.getIllustrationNamePropType)(),
  illustrationProps: _propTypes.default.object,
  Image: RenderProp.getPropType(_UIIllustration.default),
  title: (0, _createLazyPropType.default)(_propTypes.default.node)
};
UIResultsMessage.defaultProps = {
  Body: 'div',
  Image: MessageImage,
  illustrationProps: defaultIllustrationProps
};
UIResultsMessage.displayName = 'UIResultsMessage';
module.exports = exports.default;